// @flow
import * as React from 'react';
import { compose } from 'recompose';
import { withSvg } from './../../../components/Icon/withSvg';
import { GPath } from './../../../components/Icon/PathIcon';

const Icon = props => (
  <GPath fillRule="evenodd" {...props}>
    <path d="M11.2995 16.495C11.2382 16.5508 11.1767 16.6069 11.1149 16.6633C11.1144 16.6638 11.1139 16.6642 11.1133 16.6647L11.0009 16.7654C10.4312 17.2758 9.5688 17.2758 8.99913 16.7654L8.88668 16.6647C8.88614 16.6642 8.88559 16.6637 8.88505 16.6632C8.82333 16.607 8.76187 16.5509 8.7007 16.4952C6.19965 14.2151 4.16043 12.3561 2.73047 10.6106C1.2716 8.82977 0.5 7.22888 0.5 5.49499C0.5 2.67428 2.67562 0.5 5.5 0.5C7.09838 0.5 8.61032 1.23109 9.61847 2.42133L10 2.87178L10.3815 2.42132C11.3896 1.2311 12.9015 0.5 14.5 0.5C17.3244 0.5 19.5 2.67428 19.5 5.49499C19.5 7.22891 18.7284 8.8298 17.2695 10.6106C15.8396 12.3561 13.8004 14.2151 11.2995 16.495Z" />
  </GPath>
);

const SVG = compose(withSvg)(Icon);

export default ({
  viewBox = '0 0 20 18',
  height = '18',
  ...props
}: {
  viewBox?: string,
  height?: string,
  ...Object,
}) => (
  <SVG
    width="20"
    height={height}
    viewBox={viewBox}
    fill="none"
    stroke="black"
    centerAlign={false}
    {...props}
  />
);
